import { Component, OnInit, ViewChild , ElementRef } from '@angular/core';
import { RestService } from '../rest.service';
import * as Chart from 'chart.js';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { UserService } from '../user.service';
import { Spanish } from 'flatpickr/dist/l10n/es';

@Component({
  selector: 'app-bingoe',
  templateUrl: './bingoe.component.html',
  styleUrls: ['./bingoe.component.scss']
})
export class BingoeComponent implements OnInit {

  @ViewChild('content',{static: false}) content: ElementRef;

  private intervalUpdate: any = null;
  chart1;

  items: Array<any> = [];
  date: string = this.user.formatDateES(new Date());
  date_comparativa: string = this.user.formatDateES(new Date().setDate(new Date().getDate() - 366));
  point: any = [];

  salas = [
    { 'id': '1' , 'nombre': 'Bingo Libertad'},
    { 'id': '5' , 'nombre': 'Bingo Carolinas'},
    { 'id': '4' , 'nombre': 'Bingo Goya'},
    { 'id': '2' , 'nombre': 'Bingo Central Elche'},
    { 'id': '3' , 'nombre': 'Bingo Santa Pola'},
    { 'id': '6' , 'nombre': 'Bingo Plaza Gandía'},
    { 'id': '7' , 'nombre': 'Bingo Plaza Torrent'},
    { 'id': '23' , 'nombre': 'Sala Royal Ontinyent'},
    { 'id': '24' , 'nombre': 'Sala Royal Villena'},
    { 'id': '17' , 'nombre': 'Bingo Riscal'},
    { 'id': '20' , 'nombre': 'Bingo Costablanca'},
    { 'id': '21' , 'nombre': 'Bingo Navas'},
    { 'id': '22' , 'nombre': 'Bingo Gorrion'}
  ];

  zitro = '';
  degestec = '';
  final_data: any = [];

  dateTime: FlatpickrOptions = {
    enableTime: false,
    firstDayOfWeek: 1,
    defaultDate : this.date,
    dateFormat: 'd-m-Y',
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => {
      this.date = dateStr;
    }
  };

  dateTime2: FlatpickrOptions = {
    enableTime: false,
    defaultDate : this.date_comparativa,
    dateFormat: 'd-m-Y',
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => this.date_comparativa = dateStr
  };

  constructor(
    public rest: RestService,
    public user: UserService,
  ) {}

  ngOnInit() {

    this.chart1 = this.mixedChart('mix1', 'Bingo Electronico');
    this.getPoints();
    // this.intervalUpdate = setInterval(function () { this.getPoints(); }.bind(this), 900000);
  }

  private mixedChart(nombre, textTitle) {
    return new Chart(document.getElementById(nombre), {
      type: 'bar',
      data: {
        labels: [],
        datasets: [
          {
            label: 'Zitro-Jugado',
            type: 'line',
            borderColor: '#e2001a',
            data: [],
            fill: true,
            hidden: true
          },
          {
            label: 'Zitro-Acumulado',
            type: 'line',
            borderColor: '#e2001a',
            data: [],
            fill: true,
            hidden: true
          },
          {
            label: 'ZitroAA-Jugado',
            type: 'line',
            borderColor: 'tomato',
            data: [],
            fill: true,
            hidden: true
          },
          {
            label: 'ZitroAA-Acumulado',
            type: 'line',
            borderColor: 'tomato',
            data: [],
            fill: true,
            hidden: true
          },
          {
            label: 'Azul-Jugado',
            type: 'line',
            borderColor: '#0071bc',
            data: [],
            fill: true,
            hidden: true
          },
          {
            label: 'Azul-Acumulado',
            type: 'line',
            borderColor: '#0071bc',
            data: [],
            fill: true,
            hidden: true
          },
          {
            label: 'AzulAA-Jugado',
            type: 'line',
            borderColor: '#4b96c7',
            data: [],
            fill: true,
            hidden: true
          },
          {
            label: 'AzulAA-Acumulado',
            type: 'line',
            borderColor: '#4b96c7',
            data: [],
            fill: true,
            hidden: true
          }
        ]
      },
      options: {
        title: {
          display: true,
          text: textTitle
        },
        scales: {
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true
            },
            ticks: {
              beginAtZero: true
            }
          }]
        },
        events: ['click'],
        legend: {
          display: true,
          labels: {
            boxWidth: 52,
            fontSize: 14
          }
        },
        maintainAspectRatio: true,
        responsive: true
      }
    });
  }

  restAux(chart, sala, operador, fecha, index1, index2) {

    this.rest.getKPI(sala, operador, fecha).subscribe((data) => {
      const label: any = [];
      const data1: any = [];
      const data2: any = [];

      this.final_data.push({
        'nombre' : operador.replace("%20", " "),
        'fecha' : fecha,
        'valor' : data['data'].slice(-1)[0]
      });

      for (let index = 0; index < data['data'].length; index++) {
        label.push(data['data'][index]['rango']);
        data1.push(data['data'][index]['jugado']);

        if (index > 0 && data['data'][index]['acumulado'] < 0.01) {
          data['data'][index]['acumulado'] = data['data'][index - 1]['acumulado'];
          data2.push(data['data'][index]['acumulado']);
        } else {
          data2.push(data['data'][index]['acumulado']);
        }
      }

      chart.data.labels = label;
      chart.data.datasets[index1].data = data1;
      chart.data.datasets[index2].data = data2;
      chart.update();
    });

  }

  getPoints() {
    this.restAux(this.chart1, this.user.sala_id, 'BET%20ZITRO', this.date, 0, 1);
    this.restAux(this.chart1, this.user.sala_id, 'BET%20ZITRO', this.date_comparativa, 2, 3);
    this.restAux(this.chart1, this.user.sala_id, 'DEGESTEC', this.date, 4, 5);
    this.restAux(this.chart1, this.user.sala_id, 'DEGESTEC', this.date_comparativa, 6, 7);
    setTimeout(() => {
      this.user.loading = false;
    }, 1800);
  }

  destroyAndBuild() {
    this.final_data = [];
    this.user.loading = true;
    if (this.chart1) { this.chart1.destroy(); }
    this.chart1 = this.mixedChart('mix1', 'Bingo Electronico');
    this.getPoints();
  }



}
